import type { FC } from 'react'

import type { DialogFooterProps } from './types'

/**
 * Dialog custom footer component
 */
export const DialogFooter: FC<DialogFooterProps> = ({ children }) => {
  if (!children) return null

  return <div className="dialog-footer">{children}</div>
}

DialogFooter.displayName = 'DialogFooter'
